module.exports = "/wwwroot/img/content_page.png?ver=a8966adf";